module.exports = __webpack_public_path__ + "img/logo_descomplica_verde.e21cebb1.svg";